import SearchInMap from './SearchInMap';

export default SearchInMap;
